import { Component } from 'react'
import { connect } from 'react-redux'
import { TrackingHOC, ProductNameHOC } from 'hocs'
import DeviceSlider from 'components/DeviceSlider'
import { selectDevices, selectDevicesFetching } from './selectors'
import { updatePhoneId } from '../App/actions'
import { selectCurrentPhone } from '../App/selectors'

class DeviceSliderContainer extends Component {
  setDevice = (device, e) => {
    this.props.updatePhoneId(device.id)
    this.props.createEvent({
      category: 'deviceselector',
      data: {
        action: 'setDevice',
        device: { id: device.id, name: device.name }
      }
    })
  }

  render() {
    return <DeviceSlider {...this.props} setDevice={this.setDevice} />
  }
}

const mapStateToProps = (state) => ({
  devices: selectDevices(state),
  isFetching: selectDevicesFetching(state),
  currentDevice: selectCurrentPhone(state)
})

const mapDispatchToProps = (dispatch) => ({
  updatePhoneId: (phoneId, deviceName) =>
    dispatch(updatePhoneId(phoneId, deviceName))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductNameHOC(TrackingHOC(DeviceSliderContainer)))
